<div *ngIf="reportType == 'GranthoutstandingInDetails'">

  <!-- ACTION BUTTONS -->
  <div style="margin-left:80%; margin-top:2%;" class="noPrint">

    <button mat-raised-button color="primary" (click)="printPageA4()">
      Print
    </button>

    <button mat-button mat-dialog-close (click)="close()">Close</button>
  </div>

  <!-- PRINT SECTION -->
  <div id="print-section">

    <!-- ================= MAIN HEADER (FIRST PAGE ONLY) ================= -->
    <div class="main-header-wrapper">
      <table style="width:100%; border-collapse:collapse; margin-bottom:0;">
        <thead>

          <!-- TITLE ROW -->
          <tr>
            <td style="font-size:18px; font-weight:bold; text-align:center; padding:8px;border-left:1px solid black;border-right:1px solid black;border-top:1px solid black;">
              हिंदुस्तान प्रकाशन संस्था
            </td>

            <td style="font-size:20px; font-weight:bold; text-align:center; padding:8px;border-top:1px solid black;border-right:1px solid black;">
              Book Outstanding Report
            </td>

            <td style="font-size:18px; text-align:right; padding:8px; white-space:nowrap;border-top:1px solid black;border-right:1px solid black;font-weight:bold;">
              दिनांक {{ currentDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

          <!-- SUBTITLE ROW -->
          <tr style="border-top:1px solid black;">
            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-left:1px solid black;border-right:1px solid black;">
              विवेक पुस्तक प्रकाशन
            </td>

            <td style="font-size:18px; text-align:center; padding:8px; font-weight:bold;border-right:1px solid black;">
              All In Detail
            </td>

            <td style="font-size:16px; text-align:right; padding:8px; white-space:nowrap;border-right:1px solid black;font-weight:bold;">
              Date : From {{ startDate | date:'dd-MM-yyyy' }}<br>
              To {{ endDate | date:'dd-MM-yyyy' }}
            </td>
          </tr>

        </thead>
      </table>
    </div>

    <!-- ================= MAIN DATA TABLE ================= -->
    <table style="width:100%; border-collapse:collapse;">

      <!-- COLUMN HEADER — REPEATS EACH PAGE -->
      <thead class="repeat-header">
        <tr style="font-weight:bold;">

          <th style="border:1px solid black; padding:6px; font-size:15px;">
            Invoice No
          </th>

          <th style="border:1px solid black; padding:6px; font-size:15px;">
            Invoice Date
          </th>

          <th style="border:1px solid black; padding:6px; font-size:15px; text-align:left;">
            Book Seller Name
          </th>

          <th style="border:1px solid black; padding:6px; font-size:15px;">
            Mobile No
          </th>

          <th style="border:1px solid black; padding:6px; font-size:15px; text-align:right;">
            Invoice Amount
          </th>

          <th style="border:1px solid black; padding:6px; font-size:15px; text-align:right;">
            Received Amount
          </th>
<!-- 
          <th style="border:1px solid black; padding:6px; font-size:15px; text-align:right;">
            Credit Amount
          </th> -->

          <th style="border:1px solid black; padding:6px; font-size:15px; text-align:right;">
            Unpaid Amount
          </th>

        </tr>
      </thead>

      <!-- ================= BODY ================= -->
      <tbody *ngFor="let office of OutstandingInDetailFormBeans">

        <!-- OFFICE REP HEADER -->
        <tr>
          <td colspan="8"
              style="border:1px solid black; padding:6px; font-size:15px; font-weight:bold; text-align:center; background:#f0f0f0;">
            Office Representative : {{ office.off_rep_name }}
          </td>
        </tr>

        <ng-container *ngFor="let rep of office.rep_data">

          <!-- REPRESENTATIVE HEADER -->
          <tr>
            <td colspan="8"
                style="border:1px solid black; padding:6px; font-size:14px; font-weight:bold;">
              Representative : {{ rep.rep_name }} ({{ rep.rep_mobile_no }})
            </td>
          </tr>

          <!-- INVOICE ROWS -->
          <tr *ngFor="let inv of rep.inv_data">

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:center;">
              {{ inv.invoice_no }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:center;">
              {{ inv.invoice_date | date:'dd-MM-yyyy' }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px;">
              {{ inv.book_seller_name }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:center;">
              {{ inv.book_seller_mobile_no }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ inv.inv_amt }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ inv.rcv_amt || 0 }}
            </td>

            <!-- <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ inv.credit_amt || 0 }}
            </td> -->

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ inv.unpaid_amt || 0 }}
            </td>

          </tr>

          <!-- REPRESENTATIVE TOTAL -->
          <tr style="font-weight:bold; background:#fbe4d5;">

            <td colspan="4" style="border:1px solid black; padding:6px; font-size:14px;">
              Representative Total
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ rep.inv_amt_total }}
            </td>

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ rep.net_amt_total }}
            </td>
<!-- 
            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ rep.crdt_amt_total }}
            </td> -->

            <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
              {{ rep.unpaid_amt_total }}
            </td>

          </tr>

        </ng-container>

        <!-- OFFICE REP TOTAL -->
        <tr style="font-weight:bold; background:#f4b084;">

          <td colspan="4" style="border:1px solid black; padding:6px; font-size:14px;">
            Office Representative Total
          </td>

          <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
            {{ office.off_inv_amt_total }}
          </td>

          <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
            {{ office.off_net_amt_total }}
          </td>
<!-- 
          <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
            {{ office.off_crdt_amt_total }}
          </td> -->

          <td style="border:1px solid black; padding:6px; font-size:14px; text-align:right;">
            {{ office.off_unpaid_amt_total }}
          </td>

        </tr>

      </tbody>

      <!-- ================= GRAND TOTAL ================= -->
      <tfoot>
        <tr style="background:#c8753f; color:white; font-weight:bold; font-size:16px;">

          <td colspan="4" style="border:1px solid black; padding:8px;">
            Grand Total
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ OutStandingIDTotal }}
          </td>

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ OutStandingIDNetAmtTotal }}
          </td>
<!-- 
          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ OutStandingIDCrdtTotal }}
          </td> -->

          <td style="border:1px solid black; padding:8px; text-align:right;">
            Rs-{{ OutStandingIDUnPaidTotal }}
          </td>

        </tr>
      </tfoot>

    </table>

  </div>

</div>